import { render, staticRenderFns } from "./pelatihan_sertifikat.vue?vue&type=template&id=5932a656"
import script from "./pelatihan_sertifikat.vue?vue&type=script&lang=js"
export * from "./pelatihan_sertifikat.vue?vue&type=script&lang=js"
import style0 from "./pelatihan_sertifikat.vue?vue&type=style&index=0&id=5932a656&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports